import modalActions from "actions/modal";
import profileActions from "actions/profile";
import {
    BidCarsPlanningSettingsModel,
    DriverControlPointsSettingsModel,
    DriverEducationResourceModel,
    ExploitationSettingsModel,
    ExpressBidSettingsJsonObject,
    OrganizationDefaultRouteOptionsModel,
    OrganizationProfileModel,
    ProfitabilityOfBidSettingsModel,
    ReportExecutionTimeModel,
    SyncSystemModel,
    UserNotificationOptionModel,
    UserProfileModel,
} from "api";
import Profile from "components/profile";
import { generatedActions } from "helpers/redux";
import { connect } from "react-redux";
import { Action, ActionFunctionAny } from "redux-actions";

const mapStateToProps = (state: {
    profile: {
        profile: UserProfileModel;
        organization: OrganizationProfileModel;
        workRestInfo: ExpressBidSettingsJsonObject;
        bidCarsPlanningSettings: BidCarsPlanningSettingsModel;
        profitabilityOfBidSettings: ProfitabilityOfBidSettingsModel;
        controlPointsSettings: DriverControlPointsSettingsModel;
        notificationOptions: UserNotificationOptionModel[];
        executionTimes: ReportExecutionTimeModel[];
        defaultRouteOptions: OrganizationDefaultRouteOptionsModel;
        syncSystems: SyncSystemModel[];
        educationResources: DriverEducationResourceModel[];
        chatsSettings: {};
        exploitationSettings: ExploitationSettingsModel;
        refuelingSettings: {};
        roles: {};
    };
    dictionaries: { enums: {} };
    bids: {};
}) => ({
    profile: state.profile.profile,
    organization: state.profile.organization,
    workRestInfo: state.profile.workRestInfo,
    bidCarsPlanningSettings: state.profile.bidCarsPlanningSettings,
    profitabilityOfBidSettings: state.profile.profitabilityOfBidSettings,
    controlPointsSettings: state.profile.controlPointsSettings,
    roles: state.profile.roles,
    notificationOptions: state.profile.notificationOptions,
    executionTimes: state.profile.executionTimes,
    defaultRouteOptions: state.profile.defaultRouteOptions,
    enums: state.dictionaries.enums,
    syncSystems: state.profile.syncSystems,
    educationResources: state.profile.educationResources,
    chatsSettings: state.profile.chatsSettings,
    refuelingSettings: state.profile.refuelingSettings,
    exploitationSettings: state.profile.exploitationSettings,
    bids: state.bids,
});

const mapDispatchToProps = (dispatch: ActionFunctionAny<Action<Object>>) => ({
    getUser: () => dispatch(profileActions.getUser()),
    getOrg: () => dispatch(profileActions.getOrg()),
    getWorkRestInfo: () => dispatch(profileActions.getWorkRestInfo()),
    getReportExecutionTimes: () => dispatch(profileActions.getReportExecutionTimes()),
    getDriverEducationResourceSettings: () => dispatch(profileActions.getDriverEducationResourceSettings()),
    getProfitabilityOfBidSettings: () => dispatch(profileActions.getProfitabilityOfBidSettings()),
    getDefaultRouteOptions: () => dispatch(profileActions.getDefaultRouteOptions()),
    getControlPointsSettings: () => dispatch(profileActions.getControlPointsSettings()),
    getNotificationOptions: () => dispatch(profileActions.getNotificationOptions()),
    getSyncSystems: () => dispatch(profileActions.getSyncSystems()),
    getBidCarsPlanningSettings: () => dispatch(profileActions.getBidCarsPlanningSettings()),
    getChatsSettings: () => dispatch(profileActions.getChatsSettings()),
    getExploitationSettings: () => dispatch(profileActions.getExploitationSettings()),
    modal: (params: {}) => dispatch(modalActions.open(params)),
    mergeBidsParams: (params: {}) => dispatch(generatedActions.bids.merge(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
